import Joi from 'joi';
import { ProductType } from 'constants.js';

const details = {
  name: Joi.string()
    .label('Recipient Query Name')
    .min(3)
    .max(100)
    .required(),
  // ...automationOptionsValidation
  campaignOccurrenceType: Joi.string()
    .required()
    .label('Automation'),
  productName: Joi.string()
    .label('Product Type')
    .required(),
  subscriberListId: Joi.when('campaignOccurrenceType', {
    is: 'ON_DEMAND' || 'INTERNAL_SURVEY_RESPONSE',
    then: Joi.when('productType', {
      is: ProductType.List,
      then: Joi.string()
        .label('Subscribers List')
        .required()
    })
  }),
  eventSegmentation: Joi.when('productType', {
    is: ProductType.List,
    then: Joi.object({
      segmentAgainstEvent: Joi.boolean(),
      productSegmentation: Joi.when('segmentAgainstEvent', {
        is: true,
        then: Joi.string().label('Product Segmentation').required()
      })
    })
  }),
  schemaIdentifier: Joi.string()
    .label('Event Type')
    .required()
};

const design = {
  conditionExpression: Joi.object({
    valid: Joi.bool().valid(true),
    subConditionExpressions: Joi.array().min(1)
  })
};

export default {
  details,
  design,
  all: {
    ...design,
    ...details
  }
};
